var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.839,
    cy: 18.513,
    r: 18.017,
    fill: "#3D60A2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1gudwbugoa)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.618 8.035H13.37a2.772 2.772 0 0 0-2.769 2.769v17.139c0 .577.47 1.047 1.048 1.047H22.5c.577 0 1.047-.47 1.047-1.047v-17.14c0-1.14.93-2.07 2.07-2.07 1.142 0 2.07.93 2.07 2.07v10.4a.35.35 0 0 1-.349.35h-.697c0-11.856.024-10.984-.08-11.411a.35.35 0 0 0-.68.166c.064.258.067-.062.064 4.547h-1.2a.35.35 0 0 0 0 .698h1.198v6h-1.199a.35.35 0 0 0 0 .699h2.595c.577 0 1.047-.47 1.047-1.048v-10.4a2.772 2.772 0 0 0-2.768-2.769zM11.3 27.943v-17.14c0-1.11.88-2.019 1.978-2.067a2.762 2.762 0 0 0-.93 2.068v17.488h-.699a.35.35 0 0 1-.349-.35zm11.548-17.14v17.14a.35.35 0 0 1-.35.349h-.722c0-19.551-.03-18.068.063-18.434a.35.35 0 1 0-.677-.17 2.77 2.77 0 0 0-.076.475h-6.658a.35.35 0 0 0 0 .698h6.65v15.097H14.78a2.293 2.293 0 0 1 1.478-2.226.35.35 0 0 0 .067-.62c-1.064-.69-.731-2.506.757-2.484 1.475.023 1.763 1.806.72 2.484a.35.35 0 0 0 .066.62c.49.184.905.535 1.17.989a.35.35 0 0 0 .602-.353 3 3 0 0 0-1.025-1.045c1.112-1.275.332-3.405-1.558-3.394-1.95.012-2.61 2.172-1.546 3.394a2.998 2.998 0 0 0-1.43 2.635h-.173a.35.35 0 0 0 0 .699h7.17v1.635h-8.03v-9.724h7.042a.35.35 0 0 0 0-.699h-.046a2.998 2.998 0 0 0-1.43-2.636c1.118-1.281.322-3.46-1.625-3.392-1.906.068-2.526 2.19-1.478 3.392a2.98 2.98 0 0 0-1.263 1.56.35.35 0 0 0 .659.232 2.283 2.283 0 0 1 1.35-1.382.35.35 0 0 0 .068-.62c-1.034-.671-.762-2.436.68-2.483 1.524-.05 1.869 1.787.796 2.483a.35.35 0 0 0 .067.62 2.293 2.293 0 0 1 1.478 2.226h-6.299v-7.065c0-1.142.929-2.07 2.07-2.07h8.665a2.762 2.762 0 0 0-.933 2.07z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "1gudwbugoa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(9.017 8.035)",
    d: "M0 0h20.955v20.955H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.37f4e123924c708a9349e62af3b1b59e.svg";
export { ForwardRef as ReactComponent };